export function computeGroup(group) {
    return {
        about: (group === null || group === void 0 ? void 0 : group.about) || '',
        id: (group === null || group === void 0 ? void 0 : group.id) || '',
        name: (group === null || group === void 0 ? void 0 : group.name) || '',
        title: (group === null || group === void 0 ? void 0 : group.name) || '',
        isTranslate: true,
        ownersIDs: (group === null || group === void 0 ? void 0 : group.ownersIDs) || [],
        membersIDs: (group === null || group === void 0 ? void 0 : group.membersIDs) || [],
        teachersIDs: (group === null || group === void 0 ? void 0 : group.teachersIDs) || [],
        teachers: (group === null || group === void 0 ? void 0 : group.teachers) || [],
        managedTagIds: (group === null || group === void 0 ? void 0 : group.managedTagIds) || [],
        contexts: (group === null || group === void 0 ? void 0 : group.contexts) || [],
        owners: (group === null || group === void 0 ? void 0 : group.owners) || [],
        members: (group === null || group === void 0 ? void 0 : group.members) || [],
        managedTags: (group === null || group === void 0 ? void 0 : group.managedTags) || [],
        ownerTeamId: (group === null || group === void 0 ? void 0 : group.ownerTeamId) || '',
        chatLink: (group === null || group === void 0 ? void 0 : group.chatLink) || ''
    };
}
//# sourceMappingURL=ComputedGroup.js.mapexport function computeGroup(group) {
    return {
        about: (group === null || group === void 0 ? void 0 : group.about) || '',
        id: (group === null || group === void 0 ? void 0 : group.id) || '',
        name: (group === null || group === void 0 ? void 0 : group.name) || '',
        title: (group === null || group === void 0 ? void 0 : group.name) || '',
        isTranslate: true,
        ownersIDs: (group === null || group === void 0 ? void 0 : group.ownersIDs) || [],
        membersIDs: (group === null || group === void 0 ? void 0 : group.membersIDs) || [],
        teachersIDs: (group === null || group === void 0 ? void 0 : group.teachersIDs) || [],
        teachers: (group === null || group === void 0 ? void 0 : group.teachers) || [],
        managedTagIds: (group === null || group === void 0 ? void 0 : group.managedTagIds) || [],
        contexts: (group === null || group === void 0 ? void 0 : group.contexts) || [],
        owners: (group === null || group === void 0 ? void 0 : group.owners) || [],
        members: (group === null || group === void 0 ? void 0 : group.members) || [],
        managedTags: (group === null || group === void 0 ? void 0 : group.managedTags) || [],
        ownerTeamId: (group === null || group === void 0 ? void 0 : group.ownerTeamId) || '',
        chatLink: (group === null || group === void 0 ? void 0 : group.chatLink) || ''
    };
}
//# sourceMappingURL=ComputedGroup.js.map